/* eslint dot-notation:0 */
(function(angular) {
    'use strict';

    angular.module('um.categories').controller('categories.delete.controller', categoriesDeleteCtrl);

    categoriesDeleteCtrl.$inject = ['$scope', '$state', '$modalInstance', 'category', 'categoriesService',
        'wtNotifications', '$translate'];

    function categoriesDeleteCtrl($scope, $state, $modalInstance, category, categoriesService,
        wtNotifications, $translate) {
        $scope.title = 'CATEGORY_DELETE_CONFIRM';
        $scope.body = 'CATEGORY_DELETE_CONFIRM_BODYTEXT';
        $scope.params = {category: category.name};

        $scope.cancel = function() {
            $modalInstance.dismiss('cancel');
        };

        $scope.delete = function() {
            var tmpName = category.name;
            $modalInstance.dismiss('ok');
            categoriesService.deleteCategory(category.id)
                .then(function() {
                    $state.go('main.categories.overview', null, {reload: true})
                        .then(() => {
                            wtNotifications.success(
                                $translate.instant('CATEGORY_MSG_DELETE_SUCCESS', {categoryName: tmpName}, '', '')
                            );
                        });
                })
                .catch(function(err) {
                    $state.go('main.categories.overview', null, {reload: true})
                        .then(() => {
                            if (_.has(err, 'message') && !_.isUndefined(err.message)) {
                                wtNotifications.error(err.message.toUpperCase());
                            }
                        });
                });
        };
    }
})(window.angular);
